import React from "react";
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
const SideBarItem = (props) => {
    const {active,path,onClick,title} = props;
    return(
        <>
            <Link className={"menu-item"+(active ? "-active" : "")} to={path} onClick={onClick}>
                <div className={"title"+(active ? "-active" : "")}>{title}</div>
            </Link>
        </>
    )
}
SideBarItem.propTypes = {
    active: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
}

export default SideBarItem;
